<script>
export default {
  name: 'Loader',
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    dialog: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 50
    }
  },
  computed: {
    mode () {
      if (this.block) return 'block';
      else if (this.inline) return 'inline';
      else return 'dialog';
    }
  }
};
</script>

<template>
  <span
    v-if="mode==='inline' || mode === 'block'"
    class="loader-container"
    :class="mode"
  >
    <v-progress-circular
      v-if="loading"
      indeterminate
      :width="size/10"
      :size="size"
      color="secondary"
    />
  </span>
  <v-dialog
    v-else
    v-model="loading"
    content-class="loader-dialog"
    :transition="false"
    persistent
  >
    <span class="loader-dialog-container">
      <v-progress-circular
        v-if="loading"
        indeterminate
        :width="size/10"
        :size="size"
        color="secondary"
      />
    </span>
  </v-dialog>
</template>

<style lang="scss" scoped>
::v-deep .loader-dialog{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.loader-dialog-container{
  width: auto;
  padding: 4vh 7vh;
  background-color: #eee;
}
.loader-container{
  display: flex;
  align-items: center;
  justify-content: center;

  &.inline{
    display: inline-flex
  }
}
</style>
